import React, { useRef } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  alpha,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  CameraExportButton,
  exportComponentAsImage,
} from "../../../../utils/export/componentExporter";

const DisposalTwdvSummary = ({ company, twdvSummary }) => {
  const exportRef = useRef(null);
  const handleExportAsImage = async (e) => {
    e.stopPropagation();
    if (exportRef.current) {
      await exportComponentAsImage(exportRef.current, "TWDV Summary");
    }
  };

  return (
    <Paper
      ref={exportRef}
      elevation={0}
      sx={{
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        overflow: "hidden",
        bgcolor: (theme) => alpha(theme.palette.background.paper, 0.98),
        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
      }}
    >
      <Box
        sx={{
          p: 3,
          borderBottom: "1px solid",
          borderColor: "divider",
          bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant='h6' fontWeight={600} color='primary.main'>
            TWDV Summary
          </Typography>
          <CameraExportButton
            onClick={handleExportAsImage}
            tooltipTitle='Screenshot of the TWDV Summary'
          />
        </Box>
      </Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead
            sx={{
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
            }}
          >
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>CA Name</TableCell>
              <TableCell align='center' sx={{ fontWeight: 600 }}>
                YA of Purchase
              </TableCell>
              <TableCell align='center' sx={{ fontWeight: 600 }}>
                No. of Years b/f
              </TableCell>
              <TableCell align='center' sx={{ fontWeight: 600 }}>
                Hire Purchase
              </TableCell>
              <TableCell align='right' sx={{ fontWeight: 600 }}>
                TWDV
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.01),
            }}
          >
            {twdvSummary.map((row, index) => (
              <TableRow
                key={index}
                sx={{
                  height: 60,
                  "&:hover": {
                    bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
                  },
                }}
              >
                <TableCell>{row.caName}</TableCell>
                <TableCell align='center'>{row.yaOfPurchase}</TableCell>
                <TableCell align='center'>{row.noOfYearsBf}</TableCell>
                <TableCell align='center'>
                  {row.isHirePurchase ? (
                    <CheckCircleIcon color='success' fontSize='small' />
                  ) : (
                    <CancelIcon color='error' fontSize='small' />
                  )}
                </TableCell>
                <TableCell align='right'>{row.twdv.toLocaleString()}</TableCell>
              </TableRow>
            ))}
            <TableRow
              sx={{
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
                borderTop: "2px solid",
                borderColor: (theme) => alpha(theme.palette.divider, 0.3),
              }}
            >
              <TableCell colSpan={3}></TableCell>
              <TableCell align='center'>
                <strong>Total</strong>
              </TableCell>
              <TableCell align='right'>
                <strong>
                  {twdvSummary
                    .reduce((acc, row) => acc + row.twdv, 0)
                    .toLocaleString()}
                </strong>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default DisposalTwdvSummary;
